import React, { Component } from 'react';

class CategoryInput extends Component {
  constructor(props) {
    super(props);
  }

  // get the list element id to add item on it
  handleGetTagsByCategoryId = e => {
    this.props.handleGetTagsByCategoryId({
      categoryId: e.target.dataset.id,
      categoryName: e.target.dataset.name
    });
  };

  render() {
    const { categoryId, categories, language, languageFilters } = this.props;
    let result = '';
    if (categories) {
      result = categories.datos.map((item, i) => {
        return (
          <li 
            key={i} 
            data-id={item.categoryId} 
            data-name={item.categoryTag} 
            onClick={this.handleGetTagsByCategoryId}
            className={`${categoryId==item.categoryId ? 'selected-list' : ''}`}
          >
            {languageFilters[item.categoryTag.toLowerCase()]}
            <span
              data-id={item.categoryId}
              data-name={item.categoryTag}
              className="list-pop-up"
              onClick={this.handleGetTagsByCategoryId}
            >
              {language.card.input.addItemLabel}
            </span>
          </li>
        );
      });
    }

    return (
      <div className="input-container">
        <ul>
          <li>
            <ul className={'item-list list-hvover'}>{result}</ul>
          </li>
        </ul>
      </div>
    );
  }
}
export default CategoryInput;



// WEBPACK FOOTER //
// ./source/client/components/account_tag/categoryInput.jsx